import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=6b094cc1&lang=scss"
import "./login.vue?vue&type=style&index=1&id=6b094cc1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b094cc1"]])

export default __exports__